module.exports = __webpack_public_path__ + "media/audio14.86a36656.wav";